export default "__VITE_ASSET__T8sZ7uy5__"